var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bsczhu1"}},[_c('div',{staticClass:"box"},[_c('div',{staticStyle:{"height":"99%"},attrs:{"id":"bsczhu1div"}})])])}]

export { render, staticRenderFns }